import React from 'react'
import { RegisterItemInspectionProperty } from '@core/entities/register/RegisterItem/types'
import { ScheduledInspection } from '@core/entities/register/RegisterInspection/ScheduledInspection'
import { localizedStrings } from '@core/strings'
import { Box, Flex, Text } from '@fundamentals'
import { Button, IconButton } from '@common/material'
import ClearIcon from '@mui/icons-material/Clear'
import { RegisterInspectionDetailsTabs } from './RegisterInspectionDetailsTabs'
import { ArrowBack } from '@mui/icons-material'
import type { InspectionSidePanelTab } from './RegisterScheduleInspectionsCard'
import { RegisterInspection } from '@core/entities/register/RegisterInspection'

type RegisterItemInspectionSidePanelProps = {
  /** Same value as the register table item-details drawer column (`MIN_SIZE_SO_ALL_TABS_ARE_VISIBLE`). */
  width: number
  registerId: number
  registerItemId: number
  projectId?: number
  initialTab?: InspectionSidePanelTab
  config: RegisterItemInspectionProperty<string>
  scheduledInspection?: ScheduledInspection
  inspection?: RegisterInspection
  onClose: () => void
}

export const RegisterInspectionSidePanel: React.FC<
  RegisterItemInspectionSidePanelProps
> = ({
  width,
  registerId,
  registerItemId,
  projectId,
  initialTab,
  config,
  scheduledInspection,
  inspection,
  onClose,
}) => {
  return (
    <Flex
      flexDirection='column'
      sx={{
        width,
        height: '100%',
        minHeight: 0,
        boxSizing: 'border-box',
        px: 2,
        bgcolor: 'background.paper',
        overflow: 'hidden',
      }}
    >
      <Flex
        alignItems='center'
        justifyContent='space-between'
        sx={{
          pt: 2,
          overflow: 'hidden',
        }}
      >
        <Flex alignItems='center' sx={{ minWidth: 0, overflow: 'hidden' }}>
          <Button
            variant='outlined'
            size='medium'
            startIcon={<ArrowBack />}
            sx={{
              '.MuiButton-startIcon': { margin: 0 },
              py: 0.3,
              px: 0.9,
              minWidth: 0,
              mr: 2,
            }}
            onClick={onClose}
          />

          <Text
            variant='h6'
            sx={{
              minWidth: 0,
              flex: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {config.name}
          </Text>
        </Flex>
        <IconButton aria-label={localizedStrings.close} onClick={onClose}>
          <ClearIcon />
        </IconButton>
      </Flex>
      <Box
        key={scheduledInspection?.id}
        sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}
      >
        <RegisterInspectionDetailsTabs
          stickyPosition={0}
          registerId={registerId}
          registerItemId={registerItemId}
          projectId={projectId}
          initialTab={initialTab}
          scheduledInspectionId={scheduledInspection?.id}
          scheduledInspection={scheduledInspection}
          inspection={inspection}
        />
      </Box>
    </Flex>
  )
}
